'use client';

import { useEffect } from 'react';

/**
 * /pricing runs grid-free (design decision): hides the body grid plus the
 * gutter grids Navbar/Footer/ProductsMenu paint (`.grid-gutter`), via the
 * `html.grid-hidden` rule in globals.css. Removed again on unmount so the
 * homepage keeps its grid when navigating client-side.
 */
export default function GridOff() {
  useEffect(() => {
    document.documentElement.classList.add('grid-hidden');
    return () => document.documentElement.classList.remove('grid-hidden');
  }, []);

  return null;
}
